module.exports = __webpack_public_path__ + "static/media/not-visited.787d0487.svg";